import { useCallback, useEffect, useState } from 'react';
import {
  fetchTipoConceptos,
  createTipoConcepto,
  updateTipoConcepto,
  toggleTipoConceptoStatus,
} from '../services/tipoConceptos';

export function useTipoConceptosCrud() {
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isMutating, setIsMutating] = useState(false);

  const cargar = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const data = await fetchTipoConceptos();
      setItems(Array.isArray(data) ? data : []);
    } catch (err) {
      setError(err);
      setItems([]);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const crear = useCallback(async ({ tpConcepto, deTipoConcepto }) => {
    setIsMutating(true);
    try {
      return await createTipoConcepto({ tpConcepto, deTipoConcepto });
    } finally {
      setIsMutating(false);
    }
  }, []);

  const actualizar = useCallback(async (tpConcepto, deTipoConcepto) => {
    setIsMutating(true);
    try {
      return await updateTipoConcepto(tpConcepto, deTipoConcepto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  const toggleEstado = useCallback(async (tpConcepto) => {
    setIsMutating(true);
    try {
      return await toggleTipoConceptoStatus(tpConcepto);
    } finally {
      setIsMutating(false);
    }
  }, []);

  useEffect(() => {
    cargar();
  }, [cargar]);

  return { items, isLoading, error, isMutating, cargar, crear, actualizar, toggleEstado };
}